import { useMemo } from 'react';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { splitToUniqueInt } from '~utils/split';
import { CmsFile } from './CmsFile';
import { MamFile } from './MamFile';
import { NoFile } from './NoFile';

export default function ModuleFile({ data, onChange, editing }: IEntityComponentProps) {
  const assetId = getRelatedEntityIds(data, 'field_file')[0] || '';
  const mamAssetIdsRaw = data?.attributes?.field_mam_assets || '';
  const mamAssetId = useMemo(() => splitToUniqueInt(mamAssetIdsRaw)[0] || 0, [mamAssetIdsRaw]);

  if (!data) {
    return null;
  }

  const EditableDescription = (
    <EditableField
      entityType="paragraph--file"
      fieldName="attributes.field_text.value"
      data={data.attributes.field_text.value}
      {...{ editing, onChange }}
    />
  );

  if (mamAssetId) {
    return <MamFile mamAssetId={mamAssetId} description={EditableDescription} />;
  }
  if (assetId) {
    return <CmsFile assetId={assetId} description={EditableDescription} />;
  }

  return <NoFile />;
}
